// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__JRhdL"};